import React from 'react';
import {Link} from 'react-router-dom';
import './mainSideBar.css';

const MainSideBar = ({userGroups}) => {

  return (
    <div className="MainSideBarPage">
      <div className="SidebarExpandAreaContainer">
        <div className="SidebarExpandArea">
          <p>SIDEBAR</p>
        </div>
      </div>
      <div className="MainSideBar">
        <br/>
        <h1>Weaveability</h1>
        <h2>Basis Utilities</h2>
        <div className="SideBarIndex">
          {/* {<ul> */}
          {/* <li><Link to="/">User</Link></li> */}
          {/* <li><Link to="/home">Home</Link></li> */}
          {/* <li><Link to="/about">About</Link></li> */}
          {/* {userGroups.includes('infrastructure') && <li><Link to="/securityFeeds">Security Feeds</Link></li>} */}
          {/* {userGroups.includes('infrastructure') && <li><Link to="/instanceScreenshotViewer">Instance Screenshot Viewer</Link></li>} */}
          {/* {userGroups.includes('infrastructure') && <li><Link to="/hybrisSiteIdentifier">Hybris Site Identifier</Link></li>} */}
          {/* {userGroups.includes('infrastructure') && <li><Link to="/ec2Explorer">EC2 Explorer</Link></li>} */}
          {/* {userGroups.includes('infrastructure') && <li><Link to="/ec2PatchErrors">EC2 Patch Errors</Link></li>} */}
          {/* {userGroups.includes('infrastructure') && <li><Link to="/awsCostExplorer">AWS Cost Explorer</Link></li>} */}
          {/* {userGroups.includes('infrastructure') && <li><Link to="/iamExplorer">IAM Explorer</Link></li>} */}
          {/* {userGroups.includes('infrastructure') && <li><Link to="/iamExplorer/actions">- Actions</Link></li>} */}
          {/* {userGroups.includes('infrastructure') && <li><Link to="/iamExplorer/users">- Users</Link></li>} */}
          {/* {userGroups.includes('infrastructure') && <li><Link to="/iamExplorer/keys">- Keys</Link></li>} */}
          {/* {userGroups.includes('infrastructure') && <li><Link to="/iamExplorer/report">- Report</Link></li>} */}
          {/* {userGroups.includes('infrastructure') && <li><Link to="/feedback">Feedback</Link></li>} */}
          {/* <li><Link to="/404">404 Test</Link></li> */}
          {/* </ul> */}
          <ul>
            <li><Link to="/">User</Link></li>
            {/* <li><Link to="/home">Home</Link></li> */}
            {/* <li><Link to="/about">About</Link></li> */}
            {<li><Link to="/securityFeeds">Security Feeds</Link></li>}
            {<li><Link to="/instanceScreenshotViewer">Instance Screenshot Viewer</Link></li>}
            {<li><Link to="/hybrisSiteIdentifier">Hybris Site Identifier</Link></li>}
            {<li><Link to="/ec2Explorer">EC2 Explorer</Link></li>}
            {<li><Link to="/ec2ResExplorer">EC2 Reservation Explorer</Link></li>}
            {<li><Link to="/ec2PatchErrors">EC2 Patch Errors</Link></li>}
            {/* {<li><Link to="/awsCostExplorer">AWS Cost Explorer</Link></li>} */}
            {<li><Link to="/iamExplorer">IAM Explorer</Link></li>}
            {<li><Link to="/iamExplorer/actions">- Actions</Link></li>}
            {<li><Link to="/iamExplorer/users">- Users</Link></li>}
            {<li><Link to="/iamExplorer/keys">- Keys</Link></li>}
            {<li><Link to="/iamExplorer/report">- Report</Link></li>}
            {<li><Link to="/securityGroupComparer">Security Group Comparer</Link></li>}
            {<li><Link to="/landscapeInfo">Landscape Information</Link></li>}
            {<li><Link to="/instanceTerraform">Instance Terraform Format</Link></li>}
            {/* {userGroups.includes('infrastructure') && <li><Link to="/feedback">Feedback</Link></li>} */}
            {/* <li><Link to="/404">404 Test</Link></li> */}
          </ul>
        </div>
      </div>
    </div>
  );

};

export default MainSideBar;


// WEBPACK FOOTER //
// ./src/components/universal/mainSideBar/mainSideBar.js